import styled from 'styled-components';

import { fadeIn } from '../../styles/shared.style';

export const Form = styled.form`
  display: flex;
  justify-content: end;
  gap: 8px;
  padding-top: 12px;
  animation: ease-out, ${fadeIn} 0.5s ease-out;
  align-items: end;

  @media (max-width: 1200px) { 
    width: 100%;
    margin-top: 20px;
    padding: 0 0 0 0;
  }
  
`;

export const Content = styled.div<{$size?: string}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 16px 0 0;
  align-items: end;
  
  @media (max-width: 1200px) { 
    padding: ${({ $size }) => $size ? '0 16px' : '0'};
    width: 100%;
    margin: 0 0 20px 0;
    align-items: start;
  }
`;

export const MemberContainer = styled.div`
  position: relative;
  display: flex;
  gap: 5px;
  width: 100%;
`;
export const InputContainer = styled.div<{$containsError?: boolean, $membershipApplied?: boolean}>`
  
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px solid ${({ theme, $containsError, $membershipApplied }) => $containsError ?
    theme.colors.error : $membershipApplied? theme.colors.info : theme.colors.border};
  padding-right: 16px;
`;

export const InputLabel = styled.label`
  position: absolute;
  font-size: 12px;
  left: 11px;
  top: -8px;
  z-index: 2;
  padding: 0 5px;
  font-weight: 700;

  &::before {
    content: '';
    position: absolute;
    z-index: -1;
    top: 8px;
    left: 0px;
    background-color: #ffffff;
    width: 100%;
    height: 5px;
  }
`;

export const InputForm = styled.input<{$containsError?: boolean, $membershipApplied?: boolean}>`
  width: 100%;
  gap: 16px;
  border-radius: 8px;
  opacity: 0px;
  border: none;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  background-color: white;
  color: ${({ theme, $containsError, $membershipApplied }) => $containsError ?
    theme.colors.error : $membershipApplied ? theme.colors.info : theme.colors.text.primary};
  outline: none;
  box-sizing: border-box;
`;

export const ButtonForm = styled.button`
  border-radius: 50px;
  width: 100%;
  max-width: 100px;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  outline: none;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.text.inverted};
`;

export const ErrorText = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.error};
  margin-top: 4px;
  text-align: end;
  width: 100%;
`;

export const RemoveMemberButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  width: 24px;
  height: 24px;
  border: none;
  cursor: pointer;
  font-size: 20px;
  outline: none;
  padding: 0;
  margin: 0;
  color: ${({ theme }) => theme.colors.text.primary};
`;
